import { Component, OnInit } from "@angular/core";
import { DocumentRequest } from "../../_models/documentRequest";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService, AuthenticationService, FileBlobService, UserService } from "../../_services";
import { DocumentRequestService } from "../../_services/documentRequest.service";
import { LoginHelper, Role } from "../../helpers";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { EditDocumentRequestComponent } from "../editDocumentRequest/editDocumentRequest.component";
import * as moment from "moment";
import { saveAs as importedSaveAs } from "file-saver";
import { Constants } from "../../helpers/constants";
import { SelectAuditTemplateComponent } from "../selectAuditTemplate/select-audit-template.component";
import {ListMessageComponent} from "../listMessage";

@Component({
    standalone: false,
  selector: "app-request-list",
  templateUrl: 'request-list.component.html',
  styleUrls: ['./request-list.component.scss'],
})

export class RequestListComponent implements OnInit {
  documentRequests: DocumentRequest[];
  newComment = '';
  isMaster = true;
  isCreate = false;
  collapsed = false;
  documentRequestGroups: any[];
  documentRequestGroupId: number;
  selectedDocumentRequestGroup: any;
  selectedDocumentRequestGroupName: string;
  messageForSetRequestListNameVisible: boolean = false;
  highlightRequestListNameInput: boolean = false;
  cols: any[] = [
    { 'field': 'externalRequestId', 'header': 'External Request Id' },
    { 'field': 'type', 'header': 'Type' },
    { 'field': 'relatedControlsName', 'header': 'Related Controls' },
    { 'field': 'description', 'header': 'Description', width: '40%' },
    { 'field': 'contact', 'header': 'Contact' },
    { 'field': 'requestDate', 'header': 'Requested' },
    { 'field': 'accepted', 'header': 'Accepted' },
  ];

  attachmentCols: any[] = [
    { 'field': 'date', 'header': 'Date', width: '8em' },
    { 'field': 'name', 'header': 'Name' },
  ];


  constructor(
    public router: Router,
    public userService: UserService,
    public documentRequestService: DocumentRequestService,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public fileBlobService: FileBlobService,
    public dialog: MatDialog
  ) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return;
    }
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isMaster = tenantName === Constants.RiskSpongeMaster;
    this.isCreate = (currentUser.role & (Role.KingAdmin | Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;
  }

  ngOnInit(): void {
    this.loadDocumentRequestGroups();
  }

  loadDocumentRequestGroups() {
    this.documentRequestService.getDocumentRequestGroups().subscribe(s => {
      this.documentRequestGroups = s;
      if (
        this.documentRequestGroups?.length > 0 &&
        !this.selectedDocumentRequestGroup
      ) {
        this.selectedDocumentRequestGroup = this.documentRequestGroups[0];
        this.documentRequestGroupId = this.selectedDocumentRequestGroup.documentRequestGroupId;
        this.selectedDocumentRequestGroupName = this.selectedDocumentRequestGroup.name;
      }
      this.selectedDocumentRequestGroup = this.documentRequestGroups.find(t => t.documentRequestGroupId == this.documentRequestGroupId);
      if (this.selectedDocumentRequestGroup) {
        this.loadDocumentRequests();
      }
    });
  }

  selectDocumentRequestGroup(documentRequestGroup) {
    this.selectedDocumentRequestGroup = documentRequestGroup;
    this.documentRequestGroupId = documentRequestGroup.documentRequestGroupId;
    this.selectedDocumentRequestGroupName = documentRequestGroup.name;
    this.loadDocumentRequests();
  }

  loadDocumentRequests() {
    this.documentRequests = [];
    this.documentRequestService.getDocumentRequests(this.selectedDocumentRequestGroup.documentRequestGroupId).subscribe(s => {
      this.documentRequests = s;
      this.documentRequests.forEach(t => {
        t.commentRows = (t.comments || '').trim().replace(/\r/g, '\n').replace(/\n\n/g, '\n').split('\n');
        t.relatedControlsName = t.relatedControlsList.map(c => c.complianceAreaControlId).join(",");
      });
    });
  }

  edit(item = null) {
    const existingIds = this.documentRequests.map(item => item.externalRequestId);
    const newRequestId = this.generateRequestId(this.selectedDocumentRequestGroup.name, existingIds);

    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      minWidth: "300px",
      height: '90%',
      data: {
        documentRequest: item,
        documentRequestGroupId: this.selectedDocumentRequestGroup.documentRequestGroupId,
        externalRequestId: newRequestId
      }
    };

    let dialogRef = this.dialog.open(EditDocumentRequestComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      this.loadDocumentRequests();
    });
  }

  generateRequestId(name: string, existingIds: string[]): string {
    const cleanedName = name.replace(/\s*\(.*?\)\s*/g, '');
    const baseId = cleanedName.split(' ').map(word => word.charAt(0)).join('').toUpperCase();
    let requestId;
    let number = 1;

    do {
        requestId = `${baseId}-${number}`;
        number++;
    } while (existingIds.includes(requestId));

    return requestId;
  }

  dropDocumentRequest(item) {
    this.documentRequestService.deleteDocumentRequest(item.documentRequestId).subscribe(() => this.loadDocumentRequests());
  }

  public setIsAccepted(id, value) {
    this.documentRequestService.setIsAccepted(id, value).subscribe(() => this.loadDocumentRequests());
  }

  public addComment(item) {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    item.comments = ((item.comments || '') + '\r\n' + (currentUser.firstName || currentUser.lastName ? currentUser.firstName + ' ' + currentUser.lastName : currentUser.emailAddress) + ': ' + this.newComment).trim();
    this.newComment = '';
    this.documentRequestService.saveDocumentRequest(item).subscribe(() => this.loadDocumentRequests());
  }

  public DownloadAttachment(fileName: string, item) {
    this.fileBlobService
      .downloadFile(fileName, 'Request List/' + item.externalRequestId)
      .subscribe(blob => {
        importedSaveAs(new Blob([blob]), fileName);
      },
        error => {
          const errorMessage = error.status == 401 ? 'The logged in user does not have access to the file\'s location. ' : 'The referenced file no longer exists in the document library.';
          this.alertService.error(errorMessage);
        });
  }

  public AddAssessmentAttachment(documentRequestId, event, requestName) {

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.fileBlobService.postDocumentRequestAttachment(file, documentRequestId, requestName)
        .subscribe((res) => {
          this.loadDocumentRequests();
        });
    }
  }

  deleteDocumentRequestAttachment(file) {
    this.fileBlobService.deleteDocumentRequestAttachment(file.documentRequestAttachmentId)
      .subscribe((res) => {
        this.loadDocumentRequests();
      },
        (error) => {
          const errorMessage = 'An error occurred while deleting attachment.';
          this.alertService.error(errorMessage);
        });
  }

  createDocumentRequestGroup() {
    var originalName = 'Request List';
    var existingNames = this.documentRequestGroups.map(c => c.name);
    let count = 0;
    var newName = originalName;
    while (existingNames.includes(newName)) {
      count++;
      newName = `${originalName} (${count})`;
    }
    this.documentRequestService.saveDocumentRequestGroup({ name: newName }).subscribe(r => {
      this.documentRequestGroupId = r;
      this.selectedDocumentRequestGroupName = newName;
      this.loadDocumentRequestGroups();
      this.messageForSetRequestListNameVisible = true;
      this.highlightRequestListNameInput = true;
    });
  }

  saveDocumentRequestGroup() {
    const foundElement = this.documentRequestGroups.find(item => item.name === this.selectedDocumentRequestGroup.name && item.documentRequestGroupId != this.selectedDocumentRequestGroup.documentRequestGroupId);
    this.messageForSetRequestListNameVisible = false;
    this.highlightRequestListNameInput = false;
    if (foundElement) {
      this.alertService.error(this.selectedDocumentRequestGroup.name + " Already Exists!!");
      this.selectedDocumentRequestGroup.name = this.selectedDocumentRequestGroupName;
      return;
    }
    this.documentRequestService.saveDocumentRequestGroup(this.selectedDocumentRequestGroup).subscribe(() => {
      this.loadDocumentRequestGroups();
    });
  }

  deleteDocumentRequestGroup() {
    this.documentRequestService.deleteDocumentRequestGroup(this.selectedDocumentRequestGroup.documentRequestGroupId).subscribe(() => {
      this.loadDocumentRequestGroups()
      this.selectDocumentRequestGroup = null;
    });
  }
  onRequestsSetChanged(event) {
    this.selectDocumentRequestGroup(this.selectedDocumentRequestGroup);
  }

  import(event) {
    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.documentRequestService.import(file, this.documentRequestGroupId).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.loadDocumentRequests();
          this.dialog.open(ListMessageComponent, config);
          this.ngOnInit();
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  onInputRequestListName() {
    this.messageForSetRequestListNameVisible = false;
    this.highlightRequestListNameInput = false;
  }
}
